// extracted by mini-css-extract-plugin
export var cardWrapper = "_65-0";